<template>
  <v-card style="overflow: hidden; max-width: 400px; height: 350px; float: left; border-color: black" class="ma-3 pa-2">
    <div style="display: flex; flex-direction: column;">
      <div class="mt-2 mx-1" style="height: 100%; max-width: 700px; display: flex; flex-direction: row; ">
        <router-link :to="'/music/' + book.title.replace(/ /g, '-')">
          <img :src="book.itemImage" class="ma-1 mr-3"/>
        </router-link>
        <div style="display: flex; width: 100%; flex-direction: column; justify-content: center;">
          <h4 class="mt-1">{{ book.title }}</h4>
          <div >{{ book.subtitle }}</div>
          <p class="mr-2 mt-2" v-html="book.short_description"></p>

          <div class="text-xs-center">
            <v-btn :to="/music/ + book.title.replace(/ /g, '-')" color="info">
              <div class="text-center">Details</div>
            </v-btn>
          </div>
        </div>
      </div>
      <MusicButtons class="mt-2" :buttons=book.buttons></MusicButtons>
    </div>
  </v-card>
</template>

<script>
import MusicButtons from "./MusicButtons.vue";

export default {
  name: "MusicSelectionItem",
  props: {
    book: Object
  },
  components: {
    MusicButtons
  }
};
</script>

<style scoped>
.button {
  float: right;
}

img {
  width: 150px;
  float: left;
  margin: auto;
  border-radius: 4px;
}

h4 {
  display: block;
}

p>>>p {
  font-size: 11px;
}

p {
  display: inline;
  height: 50px;
  max-height: 120px;
}

v-btn {
  margin: auto;
  margin-bottom: 2px;
}
</style>